module.exports = __webpack_public_path__ + "static/media/NIFTY.c322699e.txt";